export default __webpack_public_path__ + "static/media/oops.b94c3f48.wav";